<div class="chart-container" (resized)="onResized($event)">
    <div [ngClass]="[isStandAlone? 'hc-chart-standAlone' : 'hc-chart']" [chart]="chart" #chartEl></div>
</div>